<template>
  <a-list
    class="supported-network-list"
    bordered
    size="small"
    header="Service smart contract addresses"
    item-layout="horizontal"
    :data-source="data"
  >
    <a-list-item
      slot="renderItem"
      slot-scope="item">
      {{ item.label | globalize }}
      <span class="pull-right">
        <copyable :copy-text="item.value">
          <eth-link
            :value="item.value"
            type="address"
            :explorer-url="explorerUrl"
          />
        </copyable>
      </span>
    </a-list-item>
  </a-list>
</template>

<script>
import AList from 'ant-design-vue/lib/list'
import EthLink from '@/vue/common/eth-link'
import Copyable from '@/vue/common/copyable/Copyable'

export default {
  name: 'supported-network-addresses',
  components: {
    EthLink,
    Copyable,
    AList,
    'a-list-item': AList.Item,
  },
  props: {
    explorerUrl: {
      type: String,
      required: true,
      default: '',
    },
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
@import '~ant-design-vue/lib/list/style/index.css';

</style>
